import { Navigate, useLocation } from "react-router-dom";
import { isOneOfRoles } from "../../../helpers/role";

export function RolesGuard(props: { children: any; roles: string[] }) {
  const location = useLocation();
  const auth = localStorage.getItem("auth");
  if (!(auth && isOneOfRoles(props.roles, JSON.parse(auth).role))) {
    return <Navigate to="/login" replace state={{ redirectTo: location }} />;
  }

  return props.children;
}

export default RolesGuard;
